import { render } from "./FotosView.vue?vue&type=template&id=1663fdc5"
import script from "./FotosView.vue?vue&type=script&lang=js"
export * from "./FotosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__